exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-32965c53]{display:inline-block;width:1em;height:1em;stroke-width:0;stroke:currentColor;fill:currentColor}.icon-spin[data-v-32965c53]{-webkit-animation:icon-spin-data-v-32965c53 2s infinite linear;animation:icon-spin-data-v-32965c53 2s infinite linear}.btn .icon[data-v-32965c53]{margin-right:5px;margin-left:-3px;vertical-align:middle}@-webkit-keyframes icon-spin-data-v-32965c53{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes icon-spin-data-v-32965c53{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32965c53","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Icon.vue
// module id = eJm8
// module chunks = 1